import React, { useState } from 'react';
import './ImageCard.scss';
import CloseIcon from '@material-ui/icons/Close';

function ImageCard(
  props: { file: File, src: string, deleteFile: (file: File) => void },
): JSX.Element {
  const { file, src, deleteFile } = props;
  const [ iconVisibility, setIconVisibility ] = useState(false);

  const cardStyle = {
    width: `${window.screen.width / 5}px`,
    height: `${window.screen.height / 5}px`,
  };

  const onHover = () => {
    setIconVisibility(true);
  };

  const onLeave = () => {
    setIconVisibility(false);
  };

  return (
    <div onMouseEnter={onHover} onMouseLeave={onLeave} style={cardStyle} className="image-card">
      <CloseIcon visibility={iconVisibility ? 'visibility' : 'hidden'} onClick={() => deleteFile(file)} />
      <img alt="img" src={src} />
    </div>
  );
}

export default ImageCard;
